import {
  ContentStates,
  type ContentStateEnum,
} from '../../enums/ContentStateEnum'

interface ContentStateInput {
  hasSubmittedQuery: boolean
  hasRecentItems: boolean
  isSearchLoading: boolean
  hasResultItems: boolean
}

export function deriveContentState(
  input: ContentStateInput
): Nullable<ContentStateEnum> {
  if (!input.hasSubmittedQuery && input.hasRecentItems) {
    return ContentStates.RECENTS
  }
  if (input.isSearchLoading) {
    return ContentStates.LOADING
  }
  if (input.hasSubmittedQuery && input.hasResultItems) {
    return ContentStates.RESULTS
  }
  return null
}
